import { TLShapeId } from '@tldraw/tldraw'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { getMaskingShapeId } from '../helpers'

export function useIsMasking(shapeId: TLShapeId) {
  const editor = useEditor()

  return getMaskingShapeId(editor) === shapeId
}
